import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import { Operation, PageFor } from "../../../../../../utils/Enum.types";
import { Button } from "../../../../../../stories/Button/Button";
import { Label } from "../../../../../../stories/Label/Label";
import {
  EMPTY_STRING,
  emptyFunc,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../../utils/constants";
import {
  CustomModal,
  removeMoreSpace,
  toIsoDate,
} from "../../../../../../utils/UtilFunctions";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import useAssetTableJson from "../../../../../../json/useAssetTableJson";
import { msgType, TableHeaderJsonProps } from "../../../../../../utils/types";

import Input from "../../../../../../stories/Input/Input";
import OpenIcon from "../../../../../../images/OpenIcon.svg";
import { ViewModalStyles } from "../../../../../../styles/CustomModalStyles";
import AssetDetailsTable, {
  ItemDetailsTableFor,
} from "../../../reports/assetwise/Table";
import { AssignAssetProps } from "./GroupingAsset";
import {
  itmDetailsType,
  itmType,
} from "../../../purchase/material/statesProvider/materialContext";
import MessageModal from "../../../../../../customComponents/MessageModal";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  AddItemGroupAssemblyResult,
  AddItemGroupAssemblyVars,
  AtsItemGroupOrderField,
  GetItemGroupAssemblyDetailsData,
  GetItemGroupAssemblyDetailsResponse,
  GetItemGroupAssemblyDetailsVars,
  GetItemGroupAssoicResult,
  GetItemGroupAssoicVar,
  nodeVar,
  UpdateItemGroupAssemblyResult,
  UpdateItemGroupAssemblyVars,
} from "../queries/types";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import {
  GetAssembltByNodeById,
  GetItemGroupAssemblyDetails,
  GetItemGroupAssoic,
  GetItemGroups,
} from "../queries/queries";
import { OrderDirection } from "../../../../../../utils/commonQueryTypes";
import { ItemDetailsQueryType } from "../../items/queries/types";

import MultiItemsDetailsAutocomplete from "../../../../../../customComponents/MultiItemsDetailsAutocomplete";
import useServerDateandTime from "../../../../../../customHooks/useServerDateandTime";
import { AppContext } from "../../../../../../context/context";
import { payloadTypes } from "../../../../../../context/reducer";
import {
  AddItemGroupAssembly,
  UpdateItemGroupAssembly,
} from "../queries/mutation";
import CompaniesAutocomplete from "../../../../customer/companies/CompaniesAutocomplete";
import SubsidiarySelect from "../../../../../../customComponents/SubsidiarySelect";
import SiteSelect from "../../../../../../customComponents/SiteSelect";
import useLabels from "../../../../../../customHooks/useLabels";
export const enum AssignAssetPageFor {
  GROUPING_ASSET = "GROUPING_ASSET",
  ASSIGN_ASSET = "ASSIGN_ASSET",
}
interface Props {
  setModal: React.Dispatch<React.SetStateAction<AssignAssetProps>>;
  operation: Operation;
}
interface formType {
  itm: itmType;
  itemsDetail?: itmDetailsType[];
  itmQty: number;
  assignedQty: number;
  remainingQty: number;
}

interface inEditModeType {
  flag: boolean;
  index: number;
}

export interface modalType {
  flag: boolean;
  qty: number;
}

export const emptyModal: modalType = {
  flag: false,
  qty: -1,
};

const AssociateGroupItemsDetails = ({ setModal, operation }: Props) => {
  const { Masters_Table } = useAssetTableJson();

  const { state, dispatch } = useContext(AppContext);
  const { customer_id, group_id, company_id, sub_id, siteID, junctionID } =
    useUrlParams();

  const { user_details } = useLoggedInUserDetails();

  const [groupDesc, setGroupDesc] = useState("");

  const [mapNo, setMapNo] = useState("");
  const { subsidiaryLabel, subsidiarySiteLabel, companyLabel } = useLabels();
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const [inEditMode, setInEditMode] = useState<inEditModeType>({
    flag: false,
    index: -1,
  });

  const [modalFlag, setModalFlag] = useState(emptyModal);

  const { serverDate } = useServerDateandTime();

  const [GetAssocs] = useLazyQuery<
    GetItemGroupAssoicResult,
    GetItemGroupAssoicVar
  >(GetItemGroupAssoic);

  const [GetAssembleData, { data }] = useLazyQuery<
    GetItemGroupAssemblyDetailsResponse,
    GetItemGroupAssemblyDetailsVars
  >(GetItemGroupAssemblyDetails);

  const [AssignAssets] = useMutation<
    AddItemGroupAssemblyResult,
    AddItemGroupAssemblyVars
  >(AddItemGroupAssembly, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [UpdateAssets] = useMutation<
    UpdateItemGroupAssemblyResult,
    UpdateItemGroupAssemblyVars
  >(UpdateItemGroupAssembly, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const [formData, setFormData] = useState<formType | null>(null);

  const [message, setMessage] = useState<msgType>({
    message: "",
    flag: false,
    operation: Operation.NONE,
  });

  const [selectedItems, setSelectedItems] = useState<formType[]>([]);

  const handleClearBtn = () => {
    setFormData(null);
    setSelectedItems([]);
  };

  useEffect(() => {
    if (customer_id) {
      GetAssocs({
        variables: {
          customerID: customer_id,
          itemGrpID: Number(group_id),
        },
      }).then(({ data }) => {
        if (data && data.GetItemGroupAssoic) {
          setSelectedItems(
            data.GetItemGroupAssoic.map((itm) => ({
              itm: {
                code: itm.itemDetails.code,
                label: itm.itemDetails.desc,
                value: itm.itemDetails.id,
              },
              itmQty: itm.qtyNeeded,
              isAdded: false,
              fromDb: true,
              isDeleted: false,
              isUpdated: false,
              assignedQty: 0,
              remainingQty: itm.qtyNeeded,
            }))
          );
          setGroupDesc(
            data.GetItemGroupAssoic.length
              ? data.GetItemGroupAssoic[0].itemGrpDetails.groupName
              : ""
          );
        }
      });
    }
  }, [operation, GetAssocs, customer_id, group_id]);

  useEffect(() => {
    if (
      state.grpAssemblyId &&
      operation === Operation.UPDATE &&
      selectedItems.length
    ) {
      GetAssembleData({
        variables: {
          customerID: customer_id!,
          itemGrpAssmbldID: state.grpAssemblyId,
          itemGrpID: 0,
        },
      }).then(({ data }) => {
        if (
          data &&
          data.GetItemGroupAssemblyDetails &&
          data.GetItemGroupAssemblyDetails.length
        ) {
          const updateItem = selectedItems.map((itm) => ({
            itm: {
              code: "",
              label: itm.itm.label,
              value: itm.itm.value,
            },
            itmQty: itm.itmQty,
            isAdded: false,
            fromDb: true,
            isDeleted: false,
            isUpdated: false,
            assignedQty: 0,
            remainingQty: 0,
          }));

          const updatedItemDetails: formType[] = updateItem.map((up_item) => {
            const foundItem =
              data.GetItemGroupAssemblyDetails[0].AssemblyItem.find(
                (itm) => itm.itemID === up_item.itm.value
              );

            return {
              itm: {
                code: "",
                label: up_item.itm.label,
                value: up_item.itm.value,
              },
              itemsDetail: foundItem
                ? foundItem.AssemblyItemDetails.map((res) => ({
                    itemName: "",
                    poleNum: 0,
                    value: res.itemDetailsID,
                    label: res.prodSerialNo,
                  }))
                : undefined,
              itmQty: up_item.itmQty,
              isAdded: false,
              fromDb: true,
              isDeleted: false,
              isUpdated: false,
              assignedQty: 0,
              remainingQty: 0,
            };
          });
          setSelectedItems(updatedItemDetails);
          setMapNo(data.GetItemGroupAssemblyDetails[0].mapNo);
          setGroupDesc(data.GetItemGroupAssemblyDetails[0].groupName);
        }
      });
    }
  }, [
    operation,
    GetAssocs,
    data,
    customer_id,
    state.grpAssemblyId,
    group_id,
    selectedItems.length,
  ]);

  const handleSave = () => {
    const itemFlat = selectedItems.flatMap((res) => res.itemsDetail);

    const itemDetailsMap = itemFlat.map((res) => (res ? res.value : 0));
    if (operation === Operation.CREATE)
      AssignAssets({
        variables: {
          customerID: customer_id!,
          input: {
            companyID: company_id!,
            date: toIsoDate(serverDate),
            itemDetailsIds: itemDetailsMap.filter((res) => res !== 0),
            itemGrpID: group_id!,
            ldgrID: 0,
            mapNo: removeMoreSpace(mapNo),
            serialNo: "1",
            siteID: 0,
            subsidiaryID: 0,
          },
          user_details,
        },
        refetchQueries: [
          {
            query: GetItemGroups,
            variables: {
              after: null,
              customerID: customer_id,
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsItemGroupOrderField.GROUP_NAME,
              },
              name: EMPTY_STRING,
            },
          },
          {
            query: GetItemGroupAssoic,
            variables: {
              customerID: customer_id,
              itemGrpID: group_id,
            },
          },
          {
            query: GetItemGroupAssemblyDetails,
            variables: {
              customerID: customer_id,
              itemGrpAssmbldID: 0,
              itemGrpID: group_id,
            },
          },
        ],
      }).then(({ data }) => {
        if (data && data.AddItemGroupAssembly) {
          setMessage({
            flag: true,
            message: "Assigned items successfully",
            operation: Operation.CREATE,
          });
        }
      });
    else {
      UpdateAssets({
        variables: {
          input: {
            companyID: company_id!,
            date: toIsoDate(serverDate),
            itemDetailsIds: itemDetailsMap.filter((res) => res !== 0),
            itemGrpID: group_id!,
            ldgrID: 0,
            mapNo: removeMoreSpace(mapNo),
            serialNo: "1",
            siteID: 0,
            subsidiaryID: 0,
          },
          itemGrpAssmbldID: state.grpAssemblyId,
          user_details,
        },
        refetchQueries: [
          {
            query: GetItemGroups,
            variables: {
              after: null,
              customerID: customer_id,
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsItemGroupOrderField.GROUP_NAME,
              },
              name: EMPTY_STRING,
            },
          },
          {
            query: GetItemGroupAssoic,
            variables: {
              customerID: customer_id,
              itemGrpID: group_id,
            },
          },
          {
            query: GetItemGroupAssemblyDetails,
            variables: {
              customerID: customer_id,
              itemGrpAssmbldID: 0,
              itemGrpID: group_id,
            },
          },
        ],
      }).then(({ data }) => {
        if (data && data.UpdateItemGroupAssembly) {
          setMessage({
            flag: true,
            message: "Assigned items successfully",
            operation: Operation.CREATE,
          });
        }
      });
    }
  };

  const handleMessageModalClose = () => {
    if (message.flag && message.operation !== Operation.NONE) {
      handleClearBtn();
      setModal({
        flag: false,
        operation: Operation.NONE,
      });
    }
    setMessage(emptyMessage);
  };

  useEffect(() => {
    document.addEventListener("click", () => {
      setInEditMode({
        flag: false,
        index: -1,
      });
    });
  }, []);

  const selectItemDetailsFromModalList = useCallback(
    (items: itmDetailsType[], itmQty: number, itemIndex: number) => {
      const updatedData = selectedItems.map((itm_det, i) => {
        if (itemIndex === i) {
          let finalItems: itmDetailsType[] = [];

          const onlyIds = items.map((i) => i.value);

          finalItems = itm_det.itemsDetail
            ? itm_det.itemsDetail.filter((it) =>
                onlyIds.length ? !onlyIds.includes(it.value) : true
              )
            : items;

          return {
            ...itm_det,
            itemsDetail: finalItems,
            assignedQty: finalItems.length,
            remainingQty: itmQty - finalItems.length,
          };
        } else return itm_det;
      });

      setSelectedItems(updatedData);
      setModalFlag(emptyModal);
    },
    [selectedItems]
  );
  const selectedItemDetails = useMemo(() => {
    const foundEle = selectedItems.find(
      (data, index) => index === selectedIndex
    );
    return foundEle && foundEle.itemsDetail ? foundEle.itemsDetail : [];
  }, [selectedItems, selectedIndex]);

  return (
    <div className="grouping-asset__add">
      <div className="grouping-asset__add--title">
        <Title>Group : {groupDesc}</Title>
        <img
          src={Close}
          alt=""
          onClick={() =>
            setModal({
              flag: false,
              operation: Operation.NONE,
            })
          }
        />
      </div>
      <div className="row">
        <div className="col-3 label-grid">
          <Label>{companyLabel}</Label>
          <CompaniesAutocomplete
            onChange={(newValue) => {
              if (newValue) {
                dispatch({
                  type: payloadTypes.SET_COMPANY_ID,
                  payload: {
                    companyId: newValue.node.id,
                  },
                });
              } else {
                dispatch({
                  type: payloadTypes.SET_COMPANY_ID,
                  payload: {
                    companyId: 0,
                  },
                });
                dispatch({
                  type: payloadTypes.SET_SUB_ID,
                  payload: {
                    subsidiaryId: 0,
                  },
                });
                dispatch({
                  type: payloadTypes.SET_SUB_SITE_ID,
                  payload: {
                    subSiteId: 0,
                  },
                });
              }
            }}
            onKeyDown={emptyFunc}
            value={
              state.companyId ? state.companyId : company_id ? company_id : 0
            }
            label={""}
          />
        </div>
        <div className="col-3 label-grid">
          <Label>{subsidiaryLabel}</Label>
          <SubsidiarySelect
            onChange={(newValue) => {
              if (newValue) {
                dispatch({
                  type: payloadTypes.SET_SUB_ID,
                  payload: {
                    subsidiaryId: newValue.node.id,
                  },
                });
              } else {
                dispatch({
                  type: payloadTypes.SET_SUB_ID,
                  payload: {
                    subsidiaryId: 0,
                  },
                });
                dispatch({
                  type: payloadTypes.SET_SUB_SITE_ID,
                  payload: {
                    subSiteId: 0,
                  },
                });
              }
            }}
            onKeyDown={emptyFunc}
            companyID={
              state.companyId ? state.companyId : company_id ? company_id : 0
            }
            value={
              state.subsidiaryId ? state.subsidiaryId : sub_id ? sub_id : 0
            }
            label={""}
          />
        </div>
        <div className="col-3 label-grid">
          <Label>{subsidiarySiteLabel}</Label>
          <SiteSelect
            onChange={(newValue) => {
              if (newValue) {
                dispatch({
                  type: payloadTypes.SET_SUB_SITE_ID,
                  payload: {
                    subSiteId: newValue.value,
                  },
                });
              } else {
                dispatch({
                  type: payloadTypes.SET_SUB_SITE_ID,
                  payload: {
                    subSiteId: 0,
                  },
                });
              }
            }}
            companyId={
              state.companyId ? state.companyId : company_id ? company_id : 0
            }
            subsidiaryId={
              state.subsidiaryId ? state.subsidiaryId : sub_id ? sub_id : 0
            }
            onKeyDown={emptyFunc}
            value={state.subSiteId ? state.subSiteId : siteID ? siteID : 0}
            label={""}
          />
        </div>
      </div>
      <div className="grouping-asset__add--autocomplete col-6">
        <div className="label-grid">
          <Label>Grouping Description</Label>
          <Input
            value={mapNo}
            onChange={(e) => {
              setMapNo(e.target.value);
            }}
          />
        </div>
      </div>

      {group_id ? (
        <div className="grouping-asset__add--tableblock">
          <TableContainer className="grouping-asset__add--table">
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {Masters_Table.Masters.Grouping.AssociateAssetDetails.map(
                    (th: TableHeaderJsonProps) => {
                      return <TableCell>{th.labelName}</TableCell>;
                    }
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {/* <TableRow className="grouping-asset__add--table--row">
                  <TableCell
                    id="td-center"
                    className="grouping-asset__add--table--slno"
                  ></TableCell>
                  <TableCell className="grouping-asset__add--table--desc">
                    {edit ? (
                      formData && formData.item ? (
                        formData.item.label
                      ) : (
                        ""
                      )
                    ) : (
                      <FormAutocomplete
                        className={formClasses.inputRoot}
                        options={items}
                        onKeyDown={emptyFunc}
                        value={selectedItem}
                        openOnFocus
                        forcePopupIcon
                        getOptionLabel={(option) => {
                          if ((option as includeItmQty).code) {
                            return `${(option as includeItmQty).label}(${
                              (option as includeItmQty).code
                            })`;
                          } else {
                            return `${(option as includeItmQty).label}`;
                          }
                        }}
                        onChange={(e, newValue) => {
                          if (newValue) {
                            setSelectedItem(newValue as includeItmQty);
                          } else {
                            setSelectedItem(null);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            className={formClasses.formControlRoot}
                            slotProps={{
                              inputLabel: {
                                shrink: true,
                              },
                            }}
                          />
                        )}
                      />
                    )}
                  </TableCell>
                  <TableCell id="td-center">
                    {selectedItem ? selectedItem.qty : 0}
                  </TableCell>
                  <TableCell className="grouping-asset__add--table--code"></TableCell>

                  <TableCell
                    id="td-center"
                    className="grouping-asset__add--table--actions"
                  >
                    <img src={Enter} alt="" onClick={handleSubmit} />
                  </TableCell>
                </TableRow> */}
                {selectedItems.map((res, index) => {
                  return (
                    <TableRow>
                      <TableCell id="td-center">{index + 1}</TableCell>
                      <TableCell>{res.itm ? res.itm.label : ""}</TableCell>
                      <TableCell>{res.itmQty}</TableCell>
                      <TableCell
                        className="grouping-asset__add--table--code"
                        onClick={(e) => {
                          e.stopPropagation();
                          setInEditMode({
                            flag: true,
                            index: index,
                          });
                        }}
                        // sx={{bgcolor: inEditMode.flag && inEditMode.index === index  ? "#fde68a":"#fde68a"}}
                      >
                        <div className="grouping-asset__add--table--flex">
                          <MultiItemsDetailsAutocomplete
                            onChange={(newValue) => {
                              if (newValue.length <= res.itmQty) {
                                const updatedData = selectedItems.map(
                                  (itm_det, i) => {
                                    if (index === i) {
                                      return {
                                        ...itm_det,
                                        itemsDetail: newValue,
                                        assignedQty: newValue.length,
                                        remainingQty:
                                          res.itmQty - newValue.length,
                                      };
                                    } else return itm_det;
                                  }
                                );

                                setFormData({
                                  ...res,
                                  itemsDetail: newValue,
                                  assignedQty: newValue.length,
                                  remainingQty: res.itmQty - newValue.length,
                                });

                                setSelectedItems(updatedData);
                              }
                            }}
                            onKeyDown={emptyFunc}
                            value={
                              res.itemsDetail && res.itemsDetail.length
                                ? res.itemsDetail.map(({ value }) => value)
                                : []
                              // formData && formData.itemsDetail
                              //   ? formData.itemsDetail.map(({value}) => value)
                              //   : []
                            }
                            label=""
                            input={{
                              itemID: res.itm.value,
                              ldgrID: 0,
                              query_type: ItemDetailsQueryType.TO_CREATE_MODULE,
                              stckCategoryID: 0,
                              poleNum: 0,
                              stckManufacturerID: 0,
                              stckSubCategoryID: 0,
                              stckUomID: 0,
                              stckGroupID: 0,
                              empID: user_details.id!,
                            }}
                            queryInput={{
                              companyID: company_id!,
                              customerID: customer_id!,
                              junctionID: state.junctionID,
                              siteID: state.subSiteId,
                              subsidiaryID: state.subsidiaryId,
                            }}
                          />
                          <img
                            src={OpenIcon}
                            alt="/"
                            className="data-fetch-icon"
                            onClick={() => {
                              dispatch({
                                type: payloadTypes.SET_ITEM_ID,
                                payload: {
                                  itmId: res.itm.value,
                                },
                              });
                              setSelectedIndex(index);
                              setModalFlag({
                                flag: true,
                                qty: res.itmQty,
                              });
                            }}
                          />
                        </div>
                        {/* {inEditMode.flag && inEditMode.index === index ? (
                          <div className="grouping-asset__add--table--flex">
                            <MultiItemsDetailsAutocomplete
                              onChange={(newValue) => {
                                if (newValue.length <= res.itmQty) {
                                  const updatedData = selectedItems.map(
                                    (itm_det, i) => {
                                      if (index === i) {
                                        return {
                                          ...itm_det,
                                          itemsDetail: newValue,
                                          assignedQty: newValue.length,
                                          remainingQty:
                                            res.itmQty - newValue.length,
                                        };
                                      } else return itm_det;
                                    }
                                  );

                                  setFormData({
                                    ...res,
                                    itemsDetail: newValue,
                                    assignedQty: newValue.length,
                                    remainingQty: res.itmQty - newValue.length,
                                  });

                                  setSelectedItems(updatedData);
                                }
                              }}
                              onKeyDown={emptyFunc}
                              value={
                                res.itemsDetail && res.itemsDetail.length ? res.itemsDetail.map(({value}) => value)
                                : []
                                // formData && formData.itemsDetail
                                //   ? formData.itemsDetail.map(({value}) => value)
                                //   : []
                              }
                              label=""
                              input={{
                                itemID: res.itm.value,
                                ldgrID: 0,
                                query_type: ItemDetailsQueryType.ALL,
                                stckCategoryID: 0,
                                poleNum: 0,
                                stckManufacturerID: 0,
                                stckSubCategoryID: 0,
                                stckUomID: 0,
                                stckGroupID: 0,
                                empID: user_details.id!,
                              }}
                              queryInput={{
                                companyID: company_id!,
                                customerID: customer_id!,
                                junctionID: 0,
                                siteID: 0,
                                subsidiaryID: 0,
                              }}
                              
                            />
                            <img
                              src={OpenIcon}
                              alt="/"
                              className="data-fetch-icon"
                              onClick={() => {
                                dispatch({
                                  type: payloadTypes.SET_ITEM_ID,
                                  payload: {
                                    itmId: res.itm.value,
                                  },
                                });
                                setSelectedIndex(index);
                                setModalFlag({
                                  flag: true,
                                  qty: res.itmQty,
                                });
                              }}
                            />
                          </div>
                        ) : res.itemsDetail && res.itemsDetail.length ? (
                          <>
                            {res.itemsDetail[0].label}
                            {res.itemsDetail.length - 1 ? (
                              <Button
                                mode="view"
                                onClick={(e: React.FocusEvent) => {
                                  e.stopPropagation();
                                }}
                              >
                                {res.itemsDetail.length - 1} More
                              </Button>
                            ) : (
                              <></>
                            )}
                          </>
                        ) : (
                          ""
                        )} */}
                      </TableCell>
                      <TableCell className="grouping-asset__add--table--code">
                        {res.assignedQty}
                      </TableCell>
                      <TableCell className="grouping-asset__add--table--code">
                        {res.remainingQty}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      ) : (
        <b className="nodata">Please select Item Group</b>
      )}
      {group_id ? (
        <>
          <Button mode="save" onClick={handleSave} />
          <Button mode="clear" />
          <Button
            mode="cancel"
            onClick={() =>
              setModal({
                flag: false,
                operation: Operation.NONE,
              })
            }
          />
        </>
      ) : null}

      <CustomModal
        style={ViewModalStyles}
        isOpen={modalFlag.flag}
        onRequestClose={() => {}}
        contentComponent={
          <AssetDetailsTable
            pageType={ItemDetailsTableFor.GROUPING}
            setModalFlag={setModalFlag}
            type={PageFor.MODAL}
            selectItemDetailsFromModalList={selectItemDetailsFromModalList}
            selectedItems={selectedItemDetails}
            itmQty={modalFlag.qty}
            index={selectedIndex}
          />
        }
      />

      <MessageModal
        handleClose={handleMessageModalClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </div>
  );
};

export default AssociateGroupItemsDetails;
